import React, {useEffect, useState} from 'react';
import {fetchP5, getDateString, getNewDate, postP5} from "../Utils";
import {Link, useNavigate} from 'react-router-dom';
import {
    Select,
} from "@mui/material";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";

function BowlManiaMakePicks(props) {

    let navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [config, setConfig] = useState({});
    const [currentPicks, setCurrentPicks] = useState({});
    const [pendingPicks, setPendingPicks] = useState({});
    const [submitPicksResult, setSubmitPicksResult] = useState("");
    const [eventsData, setEventsData] = useState([]);
    let defaultEntryId = 0;
    const savedEntryId = localStorage.getItem('bowlmania_entry_id');
    if (savedEntryId) {
        defaultEntryId = Number(savedEntryId);
    } else if (props.getState().bowlmania && props.getState().bowlmania.data && props.getState().bowlmania.data.config && props.getState().bowlmania.data.config.data && props.getState().bowlmania.data.config.data[0]) {
        defaultEntryId = props.getState().bowlmania.data.config.data[0].entry_id;
        localStorage.setItem('bowlmania_entry_id', defaultEntryId);
    }
    const [entryId, setEntryId] = useState(defaultEntryId);
    const [contestId, setContestId] = useState(0);

    const fetchData = () => {
        fetchP5(props.getState().userName, props.getState().password, '/api/v1/bowlmania/makepicksdata?entry_id=' + entryId, 'bowlmaniamakepicks', props)
            .then(data => {
                const config = props.getState().bowlmaniamakepicks.data.config.data;
                setConfig(config);
                setEntryId(config.entry_id);
                setContestId(config.contest_id);
                localStorage.setItem('bowlmania_contest_id', config.contest_id);
                setEventsData(props.getState().bowlmaniamakepicks.data.events.data);
                if (props.getState().bowlmaniamakepicks.data.picks.data.length) {
                    setCurrentPicks(props.getState().bowlmaniamakepicks.data.picks.data[0]);
                    setPendingPicks(props.getState().bowlmaniamakepicks.data.picks.data[0]);
                }
                if (isLoading) {
                    setIsLoading(false);
                }
            });
    };

    useEffect(() => {
        document.title = "Pick 5 BowlMania Picks";
        if (!props.getState().isLoggedIn) {
            return navigate("/");
        }
        if (isLoading) {
            fetchData();
        }
    }, []);

    function renderLoading() {
        return <div>Loading</div>;
    }

    function handleConfidenceChange(ev, e) {
        const confidence = ev.target.value;
        if (e.Confidence === confidence) {
            return;
        }
        const newEventsData = eventsData.map((event) => {
            if (event.ID === e.ID) {
                return {
                    ...event,
                    Confidence: confidence,
                };
            }
            return event;
        });
        setEventsData(newEventsData);
    }

    function handleTeamClick(eClick, ev, teamId) {
        if (ev.pickId === teamId) {
            return;
        }
        const newEventsData = eventsData.map((event) => {
            if (event.ID === ev.ID) {
                return {
                    ...event,
                    pickId: teamId,
                };
            }
            return event;
        });
        setEventsData(newEventsData);
    }

    function renderPickRow(e) {
        const team1ImageId = e.team1Id.split(":")[3];
        const team2ImageId = e.team2Id.split(":")[3];
        return (<div className="BowlManiaPickRow">
            <div>
            <div className="BowlManiaPickRowDateContainer">{getDateString(getNewDate(e.day))} {e.tv}</div>
            <div className="BowlManiaPickRowTeamsContainer">
                <div className={`BowlManiaPickRowTeamContainer ${e.pickId === e.team2Id ? 'BowlManiaPickRowTeamContainerSelected' : ''}`} onClick={(eClick) => handleTeamClick(eClick, e, e.team2Id)}>
                    <div className="BowlManiaPickRowTeamImageContainer">
                        <img alt="" className="BowlManiaPickRowTeamImage" data-mptype="image" src={`/images/teamlogos/ncaa/100/${team2ImageId}.png`}/>
                    </div>
                    <div>
                        <div className="BowlManiaPickRowTeamName">{e.team2}</div>
                        <div className="BowlManiaPickRowTeamRecord">{e.team2Record}</div>
                    </div>
                </div>
                <div className={`BowlManiaPickRowTeamContainer ${e.pickId === e.team1Id ? 'BowlManiaPickRowTeamContainerSelected' : ''}`}  onClick={(eClick) => handleTeamClick(eClick, e, e.team1Id)}>
                    <div className="BowlManiaPickRowTeamImageContainer">
                        <img alt="" className="BowlManiaPickRowTeamImage" data-mptype="image" src={`/images/teamlogos/ncaa/100/${team1ImageId}.png`}/>
                    </div>
                    <div>
                        <div className="BowlManiaPickRowTeamName">{e.team1}</div>
                        <div className="BowlManiaPickRowTeamRecord">{e.team1Record}</div>
                    </div>
                </div>
            </div>
            </div>
            <div className="BowlManiaPickRowPointsContainer">
                <div className="BowlManiaPickRowConfidenceLabel">Confidence</div>
                <Select
                    size="small"
                    value={e.Confidence}
                    onChange={(ev) => handleConfidenceChange(ev, e)}
                    variant="outlined"
                >
                    {Array.from({length: eventsData.length + 1}, (_, i) => i)
                        .map((conf) =>
                            <MenuItem key={`select-${e.ID}-${conf}`} value={conf}>{conf === 0 ? '  ' : conf}</MenuItem>
                        )}
                </Select>
            </div>
        </div>);
    }

    function submitButtonDisabled() {
        // TODO: Implement pending picks and only enable the submit button when they differ from current picks
        return false;  //JSON.stringify(currentPicks) === JSON.stringify(pendingPicks);
    }

    function handleSubmitPicksClick() {
        const picksData = eventsData.reduce((acc, curr, idx) => {
            if (!curr.pickId) {
                return acc;
            }
            if (!curr.Confidence) {
                return acc;
            }
            acc.push({
                eventId: curr.ID,
                pickId: curr.pickId,
                confidence: curr.Confidence,
                gametime: curr.day,
            });
            return acc;
        }, []);

        const postData = {
            entryId: entryId,
            contestId: contestId,
            picks: picksData,
            year: config.year
        };
        postP5(props.getState().userName, props.getState().password, '/api/v1/bowlmania/makepicks', postData)
            .then(response => response.json())
            .then(data => {
                setSubmitPicksResult(data.error ? data.error.message : "Success");
                setTimeout(() => {
                    setSubmitPicksResult('');
                }, 5000);
            }
        );
    }

    function renderData() {
        return (<div>
            <h3>{config.entry_name}</h3>
            <div>
                {eventsData.map((e) => renderPickRow(e))}
            </div>
            <div className="BowlManiaMakePicksSubmitContainer">
                <Button variant="outlined" onClick={handleSubmitPicksClick} disabled={submitButtonDisabled()}>Submit Picks</Button>
                <div className="BowlManiaMakePicksSubmitResult">{submitPicksResult}</div>
            </div>
        </div>);
    }

    return (
        <div>
            {isLoading ? renderLoading() : renderData()}
        </div>
    );
}

export default BowlManiaMakePicks;
